import { SaleNoteController as controller } from './sale-note-redux.controller'
import template from './sale-note-redux.html'

export const SaleNoteReduxComponent = {
  controller,
  template,
  require: {
    form: '^form',
  },
  bindings: {
    minSize: '@',
    placeholder: '@',
  },
}
